/*
 * Force the dingdoong cart widget into Delivery mode AND auto-fill the
 * postal-code gate so the customer sees only the Date/Time pickers.
 *
 * Why both halves are needed:
 *   - Without the Delivery click, dingdoong stays on its built-in Pickup
 *     default and overwrites every order's shipping address with the
 *     store's pickup address — wrong for delivery customers.
 *   - In Delivery mode, dingdoong gates the calendar behind a postal-code
 *     verification step. Auto-filling the store zip (28202, a known-valid
 *     local-delivery zone) unlocks the calendar without requiring
 *     customer input. Shopify's actual local-delivery rates handle the
 *     real address-zone validation at checkout.
 *
 * The fulfillment toggle and the postal-code section are CSS-hidden
 * (component-page-polish.css), so this script effectively presents
 * Date / Time as the only visible controls.
 */
(function () {
  'use strict';

  const TOGGLE_SELECTOR = '#fulfillment-method-wrapper';
  const LABEL_SELECTOR = '.ot-dingdoong-header__radio-label';
  const ZIP_INPUT_SELECTOR = '.ot-dingdoong-delivery__zipcode-input';
  const ZIP_SUBMIT_SELECTOR = '.ot-dingdoong-delivery__zipcode-submit-button';
  const CALENDAR_SELECTOR = '.ot-dingdoong-calendar';
  const DEFAULT_ZIP = '28202';

  function selectDelivery() {
    const labels = document.querySelectorAll(
      `${TOGGLE_SELECTOR} ${LABEL_SELECTOR}`
    );
    if (labels.length < 2) return;

    const deliveryLabel = Array.from(labels).find(function (element) {
      return element.textContent.trim() === 'Delivery';
    });
    if (!deliveryLabel) return;
    if (deliveryLabel.classList.contains('checked')) return;

    deliveryLabel.click();
  }

  function autofillZip() {
    const calendar = document.querySelector(CALENDAR_SELECTOR);
    if (calendar && calendar.getBoundingClientRect().height > 0) return;

    const input = document.querySelector(ZIP_INPUT_SELECTOR);
    if (!input || input.value === DEFAULT_ZIP) return;

    const valueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    ).set;
    valueSetter.call(input, DEFAULT_ZIP);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    const submitButton = document.querySelector(ZIP_SUBMIT_SELECTOR);
    if (submitButton) submitButton.click();
  }

  function ensureDeliveryReady() {
    selectDelivery();
    autofillZip();
  }

  function init() {
    ensureDeliveryReady();

    const observer = new MutationObserver(ensureDeliveryReady);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
